/**
 * themePrepaint.js — the storage key and the pre-paint script, in PLAIN JS.
 *
 * Deliberately not TypeScript. Two very different loaders need this file:
 *
 *   1. The app bundle, via theme.ts, which re-exports both constants.
 *   2. portal/vite.config.ts, which runs in NODE and injects the script into
 *      index.html at build time.
 *
 * Node cannot load a .ts file from a workspace package it treats as external,
 * so putting these two constants in TypeScript makes the injection impossible
 * and pushes you into hand-copying the script into index.html — which is the
 * drift this file exists to prevent. Plain JS is readable by both.
 *
 * The script must stay inline-able and dependency-free: it runs synchronously
 * in <head> before first paint, before any bundle exists.
 */

/** Namespaced so it cannot collide with Supabase's own localStorage keys. */
export const THEME_STORAGE_KEY = 'sighthost.theme';

/**
 * Applies the stored preference to <html> before the browser paints.
 *
 * Wrapped in try/catch in full: localStorage throws outright in Safari private
 * mode and in embedded webviews, and an exception here runs before React and
 * would leave a blank page. A missing theme is recoverable; a blank portal is not.
 */
export const THEME_PREPAINT_SCRIPT =
  `(function(){try{` +
  `var p=localStorage.getItem(${JSON.stringify(THEME_STORAGE_KEY)});` +
  `if(p!=='light'&&p!=='dark'&&p!=='system')p='system';` +
  `var r=p==='system'?(window.matchMedia('(prefers-color-scheme: dark)').matches?'dark':'light'):p;` +
  `document.documentElement.dataset.theme=r;` +
  `document.documentElement.style.colorScheme=r;` +
  `}catch(e){}})();`;
